import { useSelector } from "react-redux";

const useMiscActivityType = (miscActivityTypeId) => {
    const { miscActivityTypes } = useSelector((state) => state.configReducer);

    return miscActivityTypes[miscActivityTypeId];
};

export default useMiscActivityType;
